import { type FC } from "react";

import { Group, Paper, Progress, Text } from "@mantine/core";

import { formatBytes } from "../utils/formatBytes";

import { banner, quotaText } from "./RemoteAssetsQuotaBanner.module.css";
import { OrganizationStorage, PerAsset, PerLens } from "./messages.generated";

interface RemoteAssetsQuotaBannerProps {
    usedBytes: number;
    totalBytes: number;
    maxAssetSize: number;
    maxLensSize: number;
}

export const RemoteAssetsQuotaBanner: FC<RemoteAssetsQuotaBannerProps> = ({
    usedBytes,
    totalBytes,
    maxAssetSize,
    maxLensSize,
}) => {
    if (totalBytes === 0) return null;

    const percentage = (usedBytes / totalBytes) * 100;
    const isWarning = percentage > 80;

    return (
        <Paper p="sm" radius="md" withBorder className={banner}>
            <Group justify="space-between" mb={4}>
                <Text size="sm" className={quotaText}>
                    <OrganizationStorage />
                </Text>
                <Text size="sm" fw={500}>
                    {formatBytes(usedBytes)} / {formatBytes(totalBytes)}
                </Text>
            </Group>
            <Progress
                value={percentage}
                color={isWarning ? "var(--colors-red-v100)" : "var(--colors-yellow-v200)"}
                size="sm"
                mb={4}
            />
            <Group gap="lg">
                <Text size="xs" className={quotaText}>
                    <PerAsset size={formatBytes(maxAssetSize)} />
                </Text>
                <Text size="xs" className={quotaText}>
                    <PerLens size={formatBytes(maxLensSize)} />
                </Text>
            </Group>
        </Paper>
    );
};
